var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"number"},domProps:{"value":_vm.value},on:{"keypress":_vm.forceNumeric,"input":function($event){return _vm.updateValue($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }